import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account-info" }
const _hoisted_2 = { class: "account-info__in" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Номер лицевого счета ")
const _hoisted_4 = { class: "account-info__score-id" }

import { computed } from "vue";

import { useStore } from "@/use/useStore";

import UiHeadline from "@/plugins/ui/components/typography/UiHeadline.vue";
import UiSubhead from "@/plugins/ui/components/typography/UiSubhead.vue";
import UiTitle from "@/plugins/ui/components/typography/UiTitle.vue";

import AccountSelect from "@/components/AccountSelect.vue";
import { usePermissions } from "@/use/usePermissions";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountInfo',
  props: {
  showScoreId: { type: Boolean, default: false },
},
  setup(__props) {



const { currentUser } = useStore();

const accountName = computed(() => {
  const surname = currentUser.value?.surname;
  const name = currentUser.value?.name;
  const description = currentUser.value?.description;

  return [surname, name, description].join(" ");
});

const school = computed(() => currentUser.value?.school?.full_name);
const scoreId = computed(() => currentUser.value?.score_id);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(UiTitle, { weight: "bold" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(accountName)), 1)
        ]),
        _: 1
      }),
      _createVNode(UiSubhead, { class: "account-info__school" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(school)), 1)
        ]),
        _: 1
      }),
      (__props.showScoreId)
        ? (_openBlock(), _createBlock(UiHeadline, {
            key: 0,
            class: "account-info__score"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(scoreId)), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_unref(currentUser)?.userGroups?.find((g) => g.name === 'PARENT'))
      ? (_openBlock(), _createBlock(AccountSelect, {
          key: 0,
          class: "account-info__selector"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})